import mongoose from 'mongoose';
import reservation, { IReservationDocument } from '../schemas/reservation';

export default (mongoose.models.Reservation ||
  mongoose.model<IReservationDocument>('Reservation', reservation)) as mongoose.Model<
  IReservationDocument
>;
